'use strict'

import ApiClient from './ApiClient'

export default class AgentRepository {
  /**
   * 自分が代理指定しているユーザー一覧情報（max2人）を取得
   * @returns {*}
   */
  get () {
    return ApiClient().get(`/agents`)
  }

  /**
   * 代理操作ユーザー情報を更新
   * @param data agents
   * @returns {*}
   */
  post (data) {
    return ApiClient().post(`/agents`, data)
  }

  /**
   * 自分が代理指定されているユーザー一覧情報を取得
   * @param params ページ番号
   * @returns {*}
   */
  getRequesters (params) {
    return ApiClient().get(`/agents/requesters`, { params })
  }

  /**
   * 選択された複数IDの表示順を別の場所に移動します
   * @param {object} params
   * @returns {*}
   */
  sort (params) {
    return ApiClient().put(`/agents/sort`, params)
  }

  /**
   * 代理操作を開始
   * @param params id
   * @returns {*}
   */
  postLogin (id) {
    return ApiClient().post(`/agents/login`, id)
  }

  /**
   * 代理操作を終了
   * @returns {*}
   */
  postLogout () {
    return ApiClient().post('/agents/logout')
  }
}



// WEBPACK FOOTER //
// ./src/repositories/AgentRepository.js